import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Segmento } from 'src/app/page/segmento/segmento';
import { Funcionalidade } from 'src/app/page/funcionalidade/funcionalidade';

@Component({
  selector: 'app-plano-cadastro',
  templateUrl: './plano-cadastro.component.html',
  styleUrls: ['../../page/plano/plano-shared.scss'],
})
export class PlanoCadastroComponent {

  @Input() formulario!: FormGroup;
  @Input() segmentos: Segmento[] = [];
  @Input() funcionalidades: Funcionalidade[] = [];

  funcionalidadeSelecionada(id?: number): boolean {
    if (id == null) {
      return false;
    }
    const ids = (this.formulario.get('funcionalidadeIds')?.value ?? []) as number[];
    return ids.includes(id);
  }

  alternarFuncionalidade(id?: number): void {
    if (id == null) {
      return;
    }
    const control = this.formulario.get('funcionalidadeIds');
    const ids = [...((control?.value ?? []) as number[])];
    const indice = ids.indexOf(id);
    if (indice >= 0) {
      ids.splice(indice, 1);
    } else {
      ids.push(id);
    }
    control?.setValue(ids);
    control?.markAsDirty();
  }
}
